/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Marker } from 'react-mapbox-gl'
import styled from '@emotion/styled'
import AirportIcon from '../../../Assets/Img/airport.png'
import Map from './Map'

const MapContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
})

const MapComponent = (props) => {
  const {
    latitude,
    longitude,
    latitudeDirection,
    longitudeDirection,
    mapZoom,
  } = props

  const lat =
    Number(latitude || 0) * (latitudeDirection.toUpperCase() === 'N' ? 1 : -1)
  const lon =
    Number(longitude || 0) * (longitudeDirection.toUpperCase() === 'E' ? 1 : -1)

  return (
    <MapContainer>
      <Map
        // eslint-disable-next-line react/style-prop-object
        style="mapbox://styles/mapbox/satellite-v9"
        center={[lon || -100.2487974, lat || 25.5977387]}
        zoom={[mapZoom ? mapZoom : '3']}
        containerStyle={{
          height: '100%',
          maxHeight: '100vh',
          maxWidth: '100vw',
          width: '100%',
        }}
      >
        <Marker coordinates={[lon, lat]} anchor="bottom">
          <img
            src={AirportIcon}
            alt=""
            style={{ width: '30px', height: '30px' }}
          />
        </Marker>
      </Map>
    </MapContainer>
  )
}

export default MapComponent
